import { getColor } from '@/helpers/utils';

interface SpamScoreCellRendererProps {
  num: number | string | null | undefined;
}

const SpamScoreCellRenderer = ({ num }: SpamScoreCellRendererProps) => {
  const getSpamColor = (num: number) => {
    if ((num >= 0 && num < 30) || num === 0) return getColor('success');
    else if (num >= 30) return getColor('warning');
    else return getColor('danger');
  };
  return (
    num &&
    num !== -1 && (
      <span
        style={{ backgroundColor: getSpamColor(Number(num)) }}
        className="px-2 h-auto py-1 rounded-2 fs--2 fw-bold text-light"
      >
        {num}
      </span>
    )
  );
};

export default SpamScoreCellRenderer;
